import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { deleteStaff, getStaffSingle } from "../../../../services/staff";
import { Staff, emptyStaff } from "../../../../interfaces/staff";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminStaffDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminStaffDelete(props: AdminStaffDeleteProps) {
    const [staff, setStaff] = useState<Staff>(emptyStaff);

    const handleDelete = () => {
        deleteStaff(props.id)
            .then(response => {
                if (response.data == 0) {
                    alert(t("Staff cannot be deleted. There is data related."));
                } else {
                    props.onDelete(props.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getStaffSingle(props.id)
            .then(response => {
                setStaff(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-staff-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("Delete coach") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { staff.id == 0 && 
                    <LoadingSpinner />
                }
                { staff.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_coach_message"
                                values={{
                                    coach_name: staff.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}